import React, { Component } from 'react'
import Dropzone from 'react-dropzone'
import classNames from 'classnames'

const SUPPORTED_FORMATS = [
    'image/png',
    'image/svg',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'image/webp',
]
// TODO image/tiff

class FileUpload extends Component {
    state = {}
    render() {
        const { image, onChange } = this.props
        const parts =
            image.indexOf(';base64,') !== -1 ? image.split(';base64,') : []
        const format = (parts[0] || '').replace('data:', '')
        const unsupportedFormat = SUPPORTED_FORMATS.indexOf(format) === -1
        return (
            <Dropzone onDrop={this.onDrop}>
                {({ getRootProps, getInputProps, isDragActive }) => (
                    <div
                        {...getRootProps({ onClick: onChange })}
                        className={classNames('dropzone', {
                            'dropzone--isActive': isDragActive,
                        })}
                    >
                        {unsupportedFormat && (
                            <span className="dropzone-unsupportedFormat">
                                Preview for {format} is unavailable.
                            </span>
                        )}
                        {!unsupportedFormat && image && (
                            <div
                                className="try-intento__input-control try-intento__input-image"
                                style={{
                                    backgroundImage: `url(${image})`,
                                }}
                            />
                        )}
                        <input {...getInputProps({ name: 'image' })} />
                        {isDragActive ? (
                            <p className="try-intento__input-help">
                                Drop files here...
                            </p>
                        ) : (
                            <p className="try-intento__input-help">
                                Try dropping some files here, or click to select
                                files to upload.
                            </p>
                        )}
                    </div>
                )}
            </Dropzone>
        )
    }

    onDrop = acceptedFiles => {
        const { onChange } = this.props
        // Do something with files
        acceptedFiles.forEach(file => {
            const reader = new FileReader()
            reader.onload = () => {
                onChange({
                    target: {
                        name: 'image',
                        value: reader.result,
                    },
                })
            }
            reader.readAsDataURL(file)
        })
    }
}

const DataInputField = ({ text, image, intent, onChange }) => {
    let input = (
        <textarea
            maxLength="500"
            className="try-intento__input-control"
            placeholder="Put your text here"
            value={text}
            name="text"
            onChange={onChange}
        />
    )

    if (intent.hasImageInput) {
        input = <FileUpload image={image} onChange={onChange} />
    }

    return (
        <div className="try-intento__input try-intento__input-border">
            {input}
        </div>
    )
}

export default DataInputField



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/TryAnyIntent/DataInputField.jsx